_ = require 'underscore'
$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
CustomStickerSelectionView = require 'app/scripts/views/stickers/custom-sticker-selection-view'
DragSort = require 'app/scripts/views/lib/drag-sort'
ModelLoader = require 'app/scripts/db/model-loader'
Promise = require 'bluebird'
{ Sticker } = require 'app/scripts/models/Sticker'
Stickers = require 'app/scripts/data/stickers'
StickerSelectionView = require 'app/scripts/views/stickers/sticker-selection-view'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
l = require 'app/scripts/lib/localize'
{ dontUpsell } = require '@trello/config'
productPromoDisableOverlay = require 'app/scripts/views/templates/product_promo_disable_overlay'
stickerSelect = require 'app/scripts/views/templates/sticker_select'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ getGiphyApi, giphyStickersToTrelloStickers, mapTrelloLocaleToGiphyLocale } = require '@trello/giphy'
{ getKey, Key } = require '@trello/keybindings'
MemberState = require 'app/scripts/view-models/member-state'
Language = require '@trello/locale'
{ isChrome } = require '@trello/browser'

module.exports = class StickerPickerView extends View
  viewTitleKey: 'stickers'
  viewIcon: 'sticker'
  className: 'board-menu-content-frame'

  initialize: ->
    @me = Auth.me()
    org = @model.getOrganization() ? null

    if @me.isFeatureEnabled('additionalStickers') || org?.isFeatureEnabled('additionalStickers')
      ModelLoader.loadMemberCustomStickers(@me.id).done()

    @listenTo @me.customStickerList, 'change add remove reset', @renderCustomStickers

    @searchForStickerDebounced = _.debounce @searchForSticker, 1000

  events:
    'keyup .js-search-stickers': 'onQueryChange'
    'change .js-upload-image': 'setUploadImage'
    'change .js-use-animated-stickers': 'onAnimationPreferenceChange'

  render: ->
    @$el.empty()
    org = @model.getOrganization() ? null
    isPremium = org?.isPremium()
    isMe = Auth.me()
    data = @model.toJSON()
    data.additionalStickersEnabled = @me.isFeatureEnabled('additionalStickers') || org?.isFeatureEnabled('additionalStickers')
    data.upsellEnabled = !dontUpsell
    data.giphyStickersEnabled = featureFlagClient.get('remarkable.giphy-stickers', false)
    data.useAnimatedStickers = MemberState.getUseAnimatedStickers()

    @$el.html(stickerSelect(data))

    @renderStandardStickers()
    @renderPremiumStickers()
    @renderCustomStickers()

    @defer ->
      DragSort.refreshDraggableStickers()

    @

  _getStickers: (pack) ->
    { premium } = Stickers[pack]
    Stickers[pack].stickers.map (data) ->
      new Sticker(_.extend({ premium }, data), { @modelCache })

  _loadStickers: ($stickerList) ->
    loadingClass = 'sticker-list-loading'
    $stickerList.addClass(loadingClass)

    imgs = $stickerList.find('.sticker-select-image').get()
    imgLoads = imgs.map (img) ->
      $img = $(img)
      new Promise (resolve) ->
        $img.load resolve
        $img.error resolve

    Promise.all(imgLoads)
    .then -> $stickerList.removeClass(loadingClass)
    .done()

  renderStandardStickers: ->
    $standardStickers = @$('.js-standard-sticker-list')

    stickerViews = @_getStickers('standard').map (sticker) =>
      @subview(StickerSelectionView, sticker)

    @appendSubviews stickerViews, $standardStickers

    @_loadStickers $standardStickers

    @

  renderPremiumStickers: ->
    org = @model.getOrganization() ? null
    $parent = @$('.js-premium-stickers')
    enabled = @me.isFeatureEnabled('additionalStickers') || org?.isFeatureEnabled('additionalStickers')

    for pack, { premium } of Stickers when premium
      $stickerPack = $(templates.fill(
        'sticker_pack_selection_list',
        { displayName: l(['sticker packs', pack]) }
      ))

      $stickerPackList = $stickerPack.filter('.js-sticker-list')

      stickerViews = @_getStickers(pack).map (sticker) =>
        @subview(StickerSelectionView, sticker, { org })

      @appendSubviews stickerViews, $stickerPackList

      @_loadStickers $stickerPackList

      $parent.append $stickerPack

      if !enabled
        $stickerPackList.append(
          productPromoDisableOverlay()
        )

    @

  renderCustomStickers: ->
    org = @model.getOrganization() ? null
    $customStickerList = @$('.js-custom-sticker-list')
    $customStickerList.children().detach()

    hasCustomStickers = @me.isFeatureEnabled('customStickers') || org?.isFeatureEnabled('customStickers')

    if hasCustomStickers
      stickerSubviews = @me.customStickerList.map (sticker) =>
        @subview(CustomStickerSelectionView, sticker, { org })
      @appendSubviews stickerSubviews, $customStickerList

    else
      $customStickerList.append(
        productPromoDisableOverlay()
      )
    $customStickerList.append(
      templates.fill('sticker_select_item_upload', { id: @me.id })
    )

    @defer ->
      DragSort.refreshDraggableStickers()

    @

  setUploadImage: (e) ->
    Util.stop(e)
    $file = @$('.js-upload-image')

    if !$file.prop('files')? && $file.val()
      # Yuck, it's IE.  Let's submit the form.
      Util.uploadFile Auth.myToken(), $file, ->
      return

    files = $file[0].files
    if files.length > 0
      @uploadStickers(files)
    return

  uploadStickers: (files) ->
    _.each files, (file) =>
      reader = new FileReader()
      data = { file }

      if !Util.validFileSize(file)
        Alerts.flash('file too large', 'error')
        return

      fd = new FormData()
      fd.append('token', Auth.myToken())
      fd.append('file', file)

      reader.onload = (file) =>
        url = file.target.result
        @me.customStickerList.create { url },
          data: fd
          processData: false
          contentType: false
          error: (model) =>
            model.set('error', 'Failed')
            @setTimeout ->
              model.destroy()
            , 5000

      reader.readAsDataURL(file)
    return

  onAnimationPreferenceChange: (e) ->
    Util.stop(e)
    MemberState.setUseAnimatedStickers(e.target.checked)

  onQueryChange: (e) ->
    Util.stop(e)

    key = getKey(e)
    if key in [Key.Enter, Key.Escape]
      return

    query = e.target.value

    if @currentQuery != query
      @showSearchSpinner()

    @currentQuery = query
    if !query?.length
      @showStaticStickers()
      return

    @searchForStickerDebounced(query)

  searchForSticker: (query) ->
    if query?.length
      giphyApi = getGiphyApi().search(query, {
        limit: 48,
        rating: 'g',
        lang: mapTrelloLocaleToGiphyLocale(Language.currentLocale)
        type: 'stickers'
      }).then (results) =>
        # In case a previous search completes after the latest search.
        if query == @currentQuery
          stickers = giphyStickersToTrelloStickers(results.data, isChrome())
          @renderStickerSearchResults(stickers)
      .catch =>
        # For now just say that there are no results.
        @renderStickerSearchResults([])

  renderStickerSearchResults: (results) ->
    @$('.js-giphy-stickers-no-results').toggleClass('hide', results.length != 0)

    org = @model.getOrganization() ? null
    stickerViews = results.map (data) =>
      sticker = new Sticker(_.extend({ isGiphySticker: true, image: data.url }, data), { @modelCache })
      @subview(StickerSelectionView, sticker, { org })

    @ensureSubviews stickerViews, @$('.js-search-sticker-list')

    @showSearchResults()

    @defer ->
      DragSort.refreshDraggableStickers()

    @

  showSearchSpinner: ->
    @hideStaticStickers()
    @hideSearchResults()
    @$('.js-search-spinner').removeClass('hide')

  showStaticStickers: ->
    @hideSearchSpinner()
    @hideSearchResults()
    @$('.js-static-stickers').removeClass('hide')

  showSearchResults: ->
    @hideSearchSpinner()
    @hideStaticStickers()
    @$('.js-giphy-stickers').removeClass('hide')

  hideStaticStickers: ->
    @$('.js-static-stickers').addClass('hide')

  hideSearchSpinner: ->
    @$('.js-search-spinner').addClass('hide')

  hideSearchResults: ->
    @$('.js-giphy-stickers').addClass('hide')
